import { ReactComponent as SpinningIcon } from "assets/svgs/Oval.svg";

const Spinner = ({ className = "" }) => {
    return (
        <div className={`flex h-full w-full items-center justify-center ${className}`}>
            <SpinningIcon className="w-full fill-black40 text-black60" />
        </div>
    );
};

export default Spinner;
